/** A result field with its own name always in view; the path to it gives way when the row is short. */
export const OutputPath = ({ path }: { path: string }) => {
	const cut = path.lastIndexOf('.');
	return (
		<span title={path} className='flex min-w-0 flex-1 font-mono text-[11px] leading-4'>
			{cut > 0 && <span className='min-w-0 truncate text-gray-700'>{path.slice(0, cut + 1)}</span>}
			<span className='shrink-0 text-violet-800'>{path.slice(cut + 1)}</span>
		</span>
	);
};
